import React from "react";

type AddAttachmentProps = {
  handleAttachmentChange: any,
  isMobile?: boolean,
  showMessage?: boolean
}

const AddAttachment = (props: AddAttachmentProps) => {
  const {
    handleAttachmentChange,
    isMobile = false,
    showMessage = true
  } = props;

  return (
    <>
      <span className="add-attachment">
        <label htmlFor="fileContents" title="Add File">
          {isMobile ? <i className="icon icon-link-smartcard"></i> : <>Add File</>}
        </label>

        {showMessage && <p>
          Total uploaded files must be less than 20MB. Accepted file types: png, jpg, pdf
        </p>}
      </span>

      <input
        id="fileContents"
        name="fileContents"
        onChange={(e) => handleAttachmentChange(e)}
        style={{ visibility: "hidden", width: 0 }}
        type="file"
        accept="application/pdf,image/*"
      />
    </>
  );
};

export default AddAttachment;
